/**
 * @generated SignedSource<<b2d7c65a525bc6ebc517f50683779aa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CalculatePriceForManualOrderInput = {
  clientMutationId?: string | null;
  discountSelection: ReadonlyArray<string>;
  productSelection: ReadonlyArray<ProductSelectionInput>;
};
export type ProductSelectionInput = {
  amount: number;
  price: PriceInput;
  productId: string;
};
export type PriceInput = {
  grossPrice?: any | null;
  netPrice?: any | null;
  taxRatePercentage: any;
};
export type upsertManualOrderModal_CalculateManualOrderPriceMutation$variables = {
  input: CalculatePriceForManualOrderInput;
};
export type upsertManualOrderModal_CalculateManualOrderPriceMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly calculatePriceForManualOrder: {
        readonly price: {
          readonly grossPrice: any;
          readonly netPrice: any;
          readonly taxRatePercentage: any;
        };
      } | null;
    };
  };
};
export type upsertManualOrderModal_CalculateManualOrderPriceMutation = {
  response: upsertManualOrderModal_CalculateManualOrderPriceMutation$data;
  variables: upsertManualOrderModal_CalculateManualOrderPriceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Billing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "CalculatePriceForManualOrderPayload",
            "kind": "LinkedField",
            "name": "calculatePriceForManualOrder",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Price",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "grossPrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "netPrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taxRatePercentage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "upsertManualOrderModal_CalculateManualOrderPriceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "upsertManualOrderModal_CalculateManualOrderPriceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b6b562d3f241f635f010af2f0df3cf92",
    "id": null,
    "metadata": {},
    "name": "upsertManualOrderModal_CalculateManualOrderPriceMutation",
    "operationKind": "mutation",
    "text": "mutation upsertManualOrderModal_CalculateManualOrderPriceMutation(\n  $input: CalculatePriceForManualOrderInput!\n) {\n  Admin {\n    Billing {\n      calculatePriceForManualOrder(input: $input) {\n        price {\n          grossPrice\n          netPrice\n          taxRatePercentage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1ab3c7cb9833172fff0c24daa114440";

export default node;
